import L from 'leaflet';

const getPropertyNames = (geoJson) => {
    let properties = []
    const exclude = ['tessellate', 'extrude', 'visibility', 'altitudeMode']
    if(geoJson?.features?.length > 0) {
        properties = [...properties, ...Object.keys(geoJson.features[0].properties).filter(x => !exclude.includes(x))]
    }

    return Array.from(new Set(properties))
}

const isGeoJson = (fileName) => {
    const names = fileName?.split('.')
    return names[names.length-1]?.toLowerCase() === 'geojson'
}

const getAttributesData = (geoJson) => {
    return geoJson?.features?.map(f => f.properties)
}

const isHTML = (str) => {
    var a = document.createElement('div');
    a.innerHTML = str;

    for (var c = a.childNodes, i = c.length; i--; ) {
        if (c[i].nodeType == 1) return true;
    }

    return false;
}

const getCoordsOfArray = (data) => {
    let coords = []
    if(data.length > 0 && !Array.isArray(data[0])) {
        return [[data[0], data[1]]]
    }
    for (const chord of data) {
        if(chord.length > 0 && Array.isArray(chord[0])) {
            const _coords = getCoordsOfArray(chord)
            coords = [...coords, ..._coords]
        }
        else {
            coords = [...coords, [chord[0], chord[1]]]
        }
    }

    return coords
}

const getCoordinatesOfFeature = (feature) => {
    return getCoordsOfArray(feature?.geometry?.coordinates || [])
}

const filterFeatures = (geoJSON, filters, bounding) => {
    const str = JSON.stringify(geoJSON)
    const data = JSON.parse(str)

    if(!filters || Object.keys(filters).length === 0)
        return geoJSON

    data.features = data.features.filter(feature => {
        let filter = true
        Object.keys(filters).forEach(filterKey => {
            if(filters[filterKey]?.length === 0)
            {
                filter = true
                return
            }

            filter = filters[filterKey].includes(feature?.properties[filterKey])
        })

        return filter
    })

    let count = 0
    for (const feature of data?.features) {
        count += ShapeFileHelper.getCoordinatesOfFeature(feature)?.length || 0
        if(count >= 50000) {
            return data
        }
    }

    if(bounding) {
        const boundingBox = L.latLngBounds(
            L.latLng(bounding[3][1], bounding[3][0]), // Kuzeybatı köşe
            L.latLng(bounding[1][1], bounding[1][0])  // Güneydoğu köşe
        );
        data.features = data.features.filter(feature => {
            if(feature?.geometry?.coordinates) {
                try {
                    const _coords = ShapeFileHelper.getCoordinatesOfFeature(feature)
                    const contains = _coords.map(x => L.latLng(x)).find(c => boundingBox.contains(c))
                    if(contains)
                        return true
                }
                catch (exp) {
                    console.error(exp)
                    return true
                }
            }

            return false
        })
    }

    return data
}

function movePoint(xy, distance, bearing) {
    const deg_to_rad = 0.017453292519943295
    const R = 6371000;
    const startLatRad = deg_to_rad * xy[0];
    const startLngRad = deg_to_rad * xy[1];
    const bearingRad = deg_to_rad * bearing;
    const distanceMeter = distance;
    const newLatRad = Math.asin(Math.sin(startLatRad) * Math.cos(distanceMeter / R) +
        Math.cos(startLatRad) * Math.sin(distanceMeter / R) * Math.cos(bearingRad));
    const newLngRad = startLngRad + Math.atan2(Math.sin(bearingRad) * Math.sin(distanceMeter / R) * Math.cos(startLatRad),
        Math.cos(distanceMeter / R) - Math.sin(startLatRad) * Math.sin(newLatRad));

    const newLat = newLatRad / deg_to_rad;
    const newLng = newLngRad / deg_to_rad;

    return [newLat, newLng];
}

const getBounding = (coords, bounding) => {
    if(!coords)
        return [0, 0, 0, 0]

    return new Promise((resolve, rej) => {
        let north = coords[0];
        let east = coords[0];
        let south = coords[0];
        let west = coords[0];

        for (let i = 1; i < coords.length; i++) {
            let lat = coords[i][0];
            let lng = coords[i][1];

            // En kuzeydeki noktayı bul
            if (lat > north[0]) {
                north = coords[i];
            }

            // En güneydeki noktayı bul
            if (lat < south[0]) {
                south = coords[i];
            }

            // En doğudaki noktayı bul
            if (lng > east[1]) {
                east = coords[i];
            }

            // En batıdaki noktayı bul
            if (lng < west[1]) {
                west = coords[i];
            }

            if(i === coords.length-1) {
                const north_east = movePoint([north[0], east[1]], bounding?.northEast || 100, 45)
                const south_east = movePoint([south[0], east[1]], bounding?.southEast || 100, 135)
                const south_west = movePoint([south[0], west[1]], bounding?.southWest || 100, 225)
                const north_west = movePoint([north[0], west[1]], bounding?.northWest || 100, 315)

                return resolve([north_west, north_east, south_east, south_west])
            }
        }

        rej('Error Bounding')
    })
}

const getDataGroup = (geoJson, key, bounding) => {
    const data = []
    ShapeFileHelper.filterFeatures(geoJson, null, bounding)?.features?.forEach(f => {
        data.push(f.properties[key])
    })

    return Array.from(new Set(data))
}

const ShapeFileHelper = {
    getPropertyNames,
    isGeoJson,
    getAttributesData,
    isHTML,
    getCoordinatesOfFeature,
    filterFeatures,
    getBounding,
    movePoint,
    getDataGroup
}

export default ShapeFileHelper